module.exports = __webpack_public_path__ + "static/media/full-screen-image-4.58666ce4.jpg";